import routes from '@/modules/policies/policies-routes';
import store from '@/modules/policies/policies-store';

export default {
  routes,
  store,
};
